module.exports = __webpack_public_path__ + "img/github-logo.9ed4f412.svg";